import React from 'react';
import { Stack, Typography } from '@mui/material';
import weekDays from 'components/CompanyWorkingDays/weekDays';
import { useTranslation } from 'react-i18next';
import { isWeekend } from 'date-fns';
import viewDaysCount from 'pages/WorkSchedulesPlanner/consts';
import getTileTheme from './getTileTheme';

interface DayScaleCellProps {
  startDate: Date;
  hideBorder: boolean;
}

export default function DayScale({ startDate, hideBorder }: DayScaleCellProps) {
  const { t } = useTranslation();
  const isToday = startDate.toDateString() === new Date().toDateString();

  const startDateDay = startDate.getDate();
  const day = startDate.getDay();
  const weekDay = weekDays.find((dayItem) => dayItem.value === day);
  const weekDayLabel = weekDay ? t(weekDay.abbreviation) : '';
  const isWeekendDay = isWeekend(startDate);

  const { weekDayColor, dateColor, backgroundColor } = getTileTheme({
    today: !!isToday,
    isWeekendDay,
  });

  return (
    <Stack
      sx={{
        borderRight: hideBorder ? 'none' : '0.1rem solid',
        borderColor: 'border.main',
        backgroundColor,
        width: `calc(100% / ${viewDaysCount})`,
        height: '100%',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <Stack alignItems="center">
        <Typography
          variant="caption"
          fontWeight={isToday ? 700 : 600}
          color={weekDayColor}
          sx={{ userSelect: 'none' }}
        >
          {weekDayLabel}
        </Typography>
        <Typography
          variant="body2"
          fontWeight={700}
          color={dateColor}
          sx={{ userSelect: 'none' }}
        >
          {startDateDay}
        </Typography>
      </Stack>
    </Stack>
  );
}
